/**
 * Scarcity countdown timer – see snippets/scarcity-timer.liquid.
 *
 * data-end:         end date as a UTC timestamp in seconds (converted from the store timezone in Liquid)
 * data-behavior:    'stay' (stay at 0), 'hide' (remove the timer) or 'reset' (start a new countdown)
 * data-reset-hours: length of each new countdown when data-behavior is 'reset'
 *
 * Unlike the theme's <countdown-timer>, hiding only removes this element (never the parent section), so it is safe
 * to use as a block inside the product section.
 */
if (!customElements.get('scarcity-timer')) {
  class ScarcityTimer extends HTMLElement {
    connectedCallback() {
      this.endTime = Number(this.dataset.end) * 1000;
      this.behavior = this.dataset.behavior || 'stay';
      this.resetInterval = Math.max(1, Number(this.dataset.resetHours) || 24) * 3600 * 1000;
      this.values = {};

      this.querySelectorAll('[data-unit]').forEach((element) => {
        this.values[element.dataset.unit] = element;
      });

      if (!this.endTime) return;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const now = Date.now();

      if (now >= this.endTime) {
        if (this.behavior === 'reset') {
          // Jump to the next cycle, counted from the configured end date, so every visitor sees the same countdown.
          const cycles = Math.floor((now - this.endTime) / this.resetInterval) + 1;
          this.endTime += cycles * this.resetInterval;
        } else {
          clearInterval(this.interval);
          this.render(0);

          // Keep the timer visible in the theme editor so it can still be selected and edited.
          if (this.behavior === 'hide' && !window.Shopify?.designMode) {
            this.hidden = true;
          }

          return;
        }
      }

      this.render(this.endTime - now);
    }

    render(remaining) {
      const totalSeconds = Math.max(0, Math.floor(remaining / 1000));

      this.update('days', Math.floor(totalSeconds / 86400));
      this.update('hours', Math.floor(totalSeconds / 3600) % 24);
      this.update('minutes', Math.floor(totalSeconds / 60) % 60);
      this.update('seconds', totalSeconds % 60);
    }

    update(unit, value) {
      const element = this.values[unit];
      // Days aren't zero-padded in the design ("7 : 12 : 43 : 38")
      const text = unit === 'days' ? String(value) : String(value).padStart(2, '0');

      if (element && element.textContent !== text) {
        element.textContent = text;
      }
    }
  }

  customElements.define('scarcity-timer', ScarcityTimer);
}
